import { useState, useEffect, createContext, useContext } from 'react'
import PropTypes from 'prop-types'

import { useSessionContext } from 'hooks/SessionContext'

import Api from 'services/api'

const FeaturesContext = createContext()

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.shape()
  ]).isRequired
}

export const FeaturesContextProvider = ({ children }) => {
  const { session: { dealerId } } = useSessionContext()

  const [enabledFeatures, setEnabledFeatures] = useState(null)
  const [isEnabledFeaturesLoaded, setIsEnabledFeaturesLoaded] = useState(false)

  useEffect(() => {
    Api.FeatureCodes.enabledFeatures(dealerId)
      .then((res) => {
        setEnabledFeatures(res.features)
        setIsEnabledFeaturesLoaded(true)
      })
      .catch(() => {
        setEnabledFeatures([])
        setIsEnabledFeaturesLoaded(true)
      })
  }, [dealerId])

  return (
    <FeaturesContext.Provider value={{ enabledFeatures, isEnabledFeaturesLoaded }}>
      {children}
    </FeaturesContext.Provider>
  )
}

FeaturesContextProvider.propTypes = propTypes

export const useFeaturesContext = () => useContext(FeaturesContext)
